/* eslint-disable @nx/enforce-module-boundaries */
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import { VideoQuestionConfig } from '@hyper-inferno/video-core';

export class VideoHandler implements QuestionHandler<VideoQuestionConfig> {
  async buildConfig(el: any, ctx: ITransformationContext) {
    return el.config;
  }
}
